import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import FormGroup from "../components/forms/FormGroup";
import Input from "../components/forms/FormEl";
import {errorToast, successToast} from "../components/layout/ToastStyles";
import axios from "axios";
import {Apis} from "../util/data";

const ForgotPassword = ({setAction, setTitle}) => {

  const {register, handleSubmit} = useForm()

  const onSubmit = async (params) =>{
    try {
      await axios.get(Apis.PROD +  '/api/v1/auth/send/reset/' + params.email)
      successToast("Correo enviado")
    } catch (error){
      console.log(error)
      errorToast("Error al enviar correo")
    }
  }

  useEffect(() => {
    setAction(() => handleSubmit(onSubmit));
    setTitle("Olvide la contraseña")
  }, [])

  return(
    <React.Fragment>
      <FormGroup>
        <label>Correo</label>
        <Input type='text'  {...register("email")}/>
      </FormGroup>
    </React.Fragment>
  )

}

export default ForgotPassword
